import { CreateOrdersNoCriteria } from 'components/organisms/CreateOrdersNoCriteria/CreateOrdersNoCriteria'
import Layout from 'layout/Layout'

export const CreateOrdersNoTemplate = () => {
    return (
        <Layout>
            <CreateOrdersNoCriteria />
        </Layout>
    )
}
